import workspaceQuery from 'graphql/queries/product/ProductAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/product/ProductAuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ProductAuditByField = {
  type: 'AuditChange',
  formTitle: 'Product Audit',
  formUrl: '/Products/ProductAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Products',
  operations: ALLOW_VIEW,
};

export default ProductAuditByField;
